
export const SET_HOME_PAGE_QUERY_PARAMS = 'SET_HOME_PAGE_QUERY_PARAMS';